import axios from "@/api/axiosAuthRequired.js"
import { urlencodeFormData } from "@/utils/formData"
import { getAuthHeaders } from "@/api/auth"
import axiosAuthRequired from "@/api/axiosAuthRequired"

export const getSessionRequestById = async (instaProToken, requestId) => {
  try {
    const response = await axios({
      method: "get",
      url: process.env.INSTAPRO_API_URL + "api/v1/coach/requests/" + requestId,
      headers: {
        Authorization: "Bearer " + instaProToken,
      },
    })
    return response.data
  } catch (e) {
    return Promise.reject(e)
  }
}

export const getActionableSessionRequests = async instaProToken => {
  try {
    const response = await axios({
      method: "get",
      url: process.env.INSTAPRO_API_URL + "api/v1/coach/requests",
      headers: {
        Authorization: "Bearer " + instaProToken,
      },
    })
    return response.data
  } catch (e) {
    return Promise.reject(e)
  }
}

export const acceptSessionRequest = async (instaProToken, requestId) => {
  let body = new FormData()
  body.append("answer", "accepted")

  try {
    await axiosAuthRequired({
      method: "put",
      url:
        process.env.PROGUIDES_WEB_URL +
        "api/v2/instapro/session-request/" +
        requestId,
      headers: {
        ...getAuthHeaders(),
        "X-INSTA-TOKEN": instaProToken,
        "Content-Type": "application/x-www-form-urlencoded",
      },
      data: urlencodeFormData(body),
    })
  } catch (e) {
    return Promise.reject(e)
  }
}

export const rejectSessionRequest = async (
  instaProToken,
  requestId,
  reason
) => {
  let body = new FormData()
  body.append("answer", "rejected")
  body.append("reason", reason)

  try {
    await axiosAuthRequired({
      method: "put",
      url:
        process.env.PROGUIDES_WEB_URL +
        "api/v2/instapro/session-request/" +
        requestId,
      headers: {
        ...getAuthHeaders(),
        "X-INSTA-TOKEN": instaProToken,
        "Content-Type": "application/x-www-form-urlencoded",
      },
      data: urlencodeFormData(body),
    })
  } catch (e) {
    return Promise.reject(e)
  }
}

export const finishSessionRequest = async (instaProToken, requestId) => {
  try {
    const response = await axiosAuthRequired({
      method: "post",
      url:
        process.env.PROGUIDES_WEB_URL +
        "api/v2/instapro/session-request/" +
        requestId +
        "/finish",
      headers: {
        ...getAuthHeaders(),
        "X-INSTA-TOKEN": instaProToken,
        "Content-Type": "application/x-www-form-urlencoded",
      },
      data: {
        assets: [""],
      },
    })
    return response.data
  } catch (e) {
    return Promise.reject(e)
  }
}

export const rateStudentForSessionRequest = async (
  instaProToken,
  requestId,
  rating,
  comment
) => {
  try {
    await axios({
      method: "put",
      url:
        process.env.INSTAPRO_API_URL +
        "api/v1/coach/requests/" +
        requestId +
        "/rate",
      headers: {
        Authorization: "Bearer " + instaProToken,
      },
      data: {
        rate: rating,
        comment: comment,
      },
    })
  } catch (e) {
    return Promise.reject(e)
  }
}

export const getReportCardTopics = async (instaProToken, requestId) => {
  try {
    const response = await axios({
      method: "get",
      url:
        process.env.INSTAPRO_API_URL +
        "api/v1/coach/requests/" +
        requestId +
        "/report_card_topics",
      headers: {
        Authorization: "Bearer " + instaProToken,
      },
    })
    return response.data
  } catch (e) {
    return Promise.reject(e)
  }
}

export const submitReportCard = async (instaProToken, requestId, data) => {
  try {
    const response = await axios({
      method: "put",
      url:
        process.env.INSTAPRO_API_URL +
        "api/v1/coach/requests/" +
        requestId +
        "/report_card",
      headers: {
        Authorization: "Bearer " + instaProToken,
      },
      data: data,
    })
    return response.data
  } catch (e) {
    return Promise.reject(e)
  }
}



// WEBPACK FOOTER //
// ./src/api/user/coaching/sessionRequests.js